
import Vue from 'vue'
import UiIcon from '@/components/common/UiIcon.vue'
import moment from 'moment'
import BaseListContainer from '@/containers/base/BaseListContainer.vue'
import ProspectFilter from '@/components/filters/ProspectFilter.vue'
import PageLayout from '@/layouts/Page.vue'
import PageMenuLayout from '@/layouts/PageMenu.vue'
import SelectRef from '@/components/common/SelectRef.vue'
import SelectConseiller from '@/components/common/SelectConseiller.vue'
import {Component, Watch} from 'vue-property-decorator'
import {Action, Getter, namespace} from 'vuex-class'
import {isEmptyObject} from '@/helpers'
import {optionsVslim} from '@/config/v-slim-dialog'

const prospectModule = namespace('prospect')
const groupeModule = namespace('groupe')

@Component({
  components: {
    UiIcon,
    PageLayout,
    PageMenuLayout,
    BaseListContainer,
    ProspectFilter,
    SelectRef,
    SelectConseiller
  }
})
export default class ProspectList extends Vue {
  @prospectModule.Action('getProspectsAction') getProspects: any
  @prospectModule.Action('getProspectByIdAction') getProspectById: any
  @prospectModule.Action('saveProspectSortParamsAction') saveProspectSortParams: any
  @prospectModule.Action('saveProspectFilterParamsAction') saveProspectFilterParams: any
  @prospectModule.Action('saveProspectLimitParamAction') saveProspectLimitParam: any
  @prospectModule.Action('deleteProspectAction') deleteProspect: any
  @prospectModule.Getter('prospectsGetter') prospects: any
  @prospectModule.Getter('prospectGetter') prospect: any
  @prospectModule.Getter('prospectSortParamsGetter') prospectSortParams: any
  @prospectModule.Getter('prospectPaginationParamsGetter') prospectPaginationParams: any
  @prospectModule.Action('batchProspectAction') batchProspect: any
  @groupeModule.Action('getGroupesAction') getGroupes: any
  @groupeModule.Getter('groupesGetter') groupes: any
  @groupeModule.Action('syncGroupeProspectAction') syncGroupeProspect: any

  rows = [
    {name: 'Id', key: 'ID', orderable: true},
    {name: 'Nom', key: 'NOM', orderable: true},
    {name: 'Lot', key: 'NOMBRE_LOTS_PRINCIPAUX', orderable: true},
    {name: 'Dep / Pays', key: 'CODE_REF_DEPARTEMENT', orderable: true},
    {name: 'Date ouverture', key: 'DATE_OUVERTURE', orderable: true},
    {name: 'Dernier échange', key: 'DATE_DERNIER_ECHANGE', orderable: true},
    {name: 'Prochaine action', key: 'DATE_PROCHAINE_ACTION', orderable: true},
    {name: 'Statut', key: 'CODE_REF_STATUT', orderable: true},
    {name: '', key: 'PROPOSITION', orderable: false},
    {name: '', key: 'ALERTE', orderable: false}
  ]

  selectAll = false
  selected = []

  panel = null

  get currentProspectIds() {
    return (this.prospects || []).map((item: any) => item.ID)
  }

  get hasSelected() {
    return this.selected.length > 0
  }

  get selectedLength() {
    return this.selected.length
  }

  get selectedLabel() {
    if (this.selected.length > 1) return 'prospects sélectionnés'
    if (this.selected.length === 1) return 'prospect sélectionné'
    return 'prospects sélectionnés'
  }

  @Watch('$route.query', {deep: false})
  watchRouteParams(val: any) {
    if (isEmptyObject(val)) this.getProspects({})
  }

  @Watch('selectAll', {deep: false})
  watchSelectAll(val: any) {
    if (val) {
      this.selected = this.currentProspectIds
    } else {
      if (this.selected.length === this.currentProspectIds.length) this.selected = []
    }
  }

  @Watch('selected', {deep: false})
  watchSelected(val: any) {
    if (val.length > 0 && val.length === this.currentProspectIds.length) {
      this.selectAll = true
    } else {
      this.selectAll = false
    }
  }

  mounted() {
    this.getGroupes()
    this.getProspects(this.$route.query)
  }

  beforeDestroy() {
    if (this.panel) this.panel.hide()
  }

  getClassOfAlert(items) {
    const lastAlert = items[0]
    if (moment(lastAlert.DATE_HEURE).isAfter(moment())) return 'bg-green'
    else return 'bg-red'
  }

  previewHandler(id: number) {
    this.getProspectById(id).then((data: any) => {
      this.panel = this.$showPanel({
        component: 'prospectPanel',
        openOn: 'right',
        width: 400,
        keepAlive: false,
        props: {
          data
        }
      })
    })
  }

  onDetailHandler(item: any) {
    const id = item.ID
    const routeData = this.$router.resolve({name: 'prospectDetail', params: {id}})
    window.open(routeData.href, '_blank')
  }

  onSortHandler(params: any) {
    this.onResetSelectHandler()
    this.saveProspectSortParams(params)
    const query = {
      ...this.$route.query,
      ...params
    }
    this.getProspects(query)
    this.$router.replace({path: this.$route.params[0], query})
  }

  onPaginateHandler(page) {
    this.onResetSelectHandler()
    const query = {
      ...this.$route.query,
      page
    }
    this.getProspects(query)
    this.$router.replace({path: this.$route.params[0], query})
  }

  onPaginatePrevHandler(page) {
    this.onPaginateHandler(page)
  }

  onPaginateNextHandler(page) {
    this.onPaginateHandler(page)
  }

  onChangeLimitHandler(limit) {
    this.onResetSelectHandler()
    this.saveProspectLimitParam(limit)
    const query = {
      ...this.$route.query,
      limit
    }
    this.getProspects(query)
    this.$router.replace({path: this.$route.params[0], query})
  }

  onFilterHandler(data) {
    this.onResetSelectHandler()
    this.saveProspectFilterParams(data)
    const query = {
      action: 'filtre',
      ...this.$route.query,
      ...data,
      page: null
    }
    this.getProspects(query)
    this.$router.replace({path: this.$route.params[0], query})
  }

  onResetFilterHandler() {
    this.onResetSelectHandler()
    this.getProspects(null)
    this.$router.replace({path: this.$route.params[0], query: null})
  }

  onResetSelectHandler() {
    this.selectAll = false
    this.selected = []
  }

  async deleteHandler(id: number) {
    const {ok} = await this.$dialogs.confirm('Confirmez vous la suppression du prospect ?', optionsVslim)
    if (ok) {
      this.deleteProspect(id)
    }
  }

  async onSelectGroupeHandler(event: any) {
    const value = event.currentTarget.value
    if (parseInt(value)) {
      this.addProspectGroupeHandler(value, this.selected)
    }
  }

  async onSelectRefStatutHandler(event: any) {
    const value = event.currentTarget.value
    if (value !== '') {
      this.batchProspectHandler(this.selected, 'CODE_REF_STATUT', value)
    }
  }

  async onSelectConseillerHandler(event: any) {
    const value = event.currentTarget.value
    if (value !== '') {
      this.batchProspectHandler(this.selected, 'ID_CONSEILLER', value)
    }
  }

  async addProspectGroupeHandler(groupeId, prospectIds) {
    this.syncGroupeProspect({
      id: groupeId,
      formParams: {
        IDS_PROSPECT: prospectIds
      }
    }).then(async (data) => {
      if (data) {
        Vue.notify({
          group: 'user',
          type: 'success',
          title: 'Confirmation',
          text: `${prospectIds.length} prospect(s) ajouté(s) au groupe ${data.NOM}`
        })
      }
      this.onResetSelectHandler()
    })
  }

  async batchProspectHandler(prospectIds, field, value) {
    this.batchProspect({
      IDS: prospectIds,
      FIELD: field,
      VALUE: value
    }).then(async (data) => {
      if (data) {
        Vue.notify({
          group: 'user',
          type: 'success',
          title: 'Confirmation',
          text: `${data.batchResult} prospect(s) assigné(s)`
        })
      }
      this.onResetSelectHandler()
      this.getProspects(this.$route.query)
    })
  }

  emailBuilderHandler(ids: Array<number>) {
    const prospects = this.prospects.filter((item: any) => ids.includes(item.ID))
    this.panel = this.$showPanel({
      component: 'emailBuilderBulkPanel',
      openOn: 'right',
      width: 700,
      keepAlive: false,
      props: {
        prospects
      }
    })
  }

  smsBuilderHandler(ids: Array<number>) {
    const prospects = this.prospects.filter((item: any) => ids.includes(item.ID))
    this.panel = this.$showPanel({
      component: 'smsBuilderPanel',
      openOn: 'right',
      width: 700,
      keepAlive: false,
      props: {
        prospects
      }
    })
  }
}
